import useObservable from './UseObservable';
import PermissionService from 'services/PermissionService';

const permissionService = PermissionService.getInstance();

const usePermission = () => {
  const [permissionsList = []] = useObservable(permissionService.getPermissionsList());

  const fetchPermissions = (params: any) => permissionService.fetch(params);

  return {
    fetchPermissions,
    permissionsList,
  };
};

export default usePermission;
